import { FamiliarSituationDetails, FamiliarSituationDetailsSchema, MaritalStatus } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteSelectFormField } from '@/components/shared/components/NewContextForms/AutocompleteSelectFormField';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { getBlankDefaultValuesFromZodSchema } from '@/utils/getBlankDefaultValuesFromZodSchema';

import { maritalRegimeArray, maritalStatusArray } from '../config';

export interface FamiliarSituationFormProps extends FormGridOptions {
  familiarSituationDetails?: FamiliarSituationDetails;
}

const blankFamiliarSituationFormValues = getBlankDefaultValuesFromZodSchema(FamiliarSituationDetailsSchema);

export function FamiliarSituationForm({
  familiarSituationDetails = blankFamiliarSituationFormValues,
  fullWidth,
  fieldVariant,
  direction,
}: FamiliarSituationFormProps) {
  const watch = useFormContext()?.watch;
  const setValue = useFormContext()?.setValue;
  const maritalStatus = watch ? watch('maritalStatus') : familiarSituationDetails.maritalSituation.maritalStatus;

  useEffect(() => {
    if (maritalStatus !== MaritalStatus.MARRIED && setValue) {
      setValue('maritalRegime', undefined);
    }
  }, [maritalStatus, setValue]);

  return (
    <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction}>
      <AutocompleteSelectFormField
        name={'maritalStatus'}
        label={'MARITAL_STATUS'}
        value={familiarSituationDetails.maritalSituation.maritalStatus}
        selectOptions={maritalStatusArray}
        fieldVariant={fieldVariant}
      />
      {maritalStatus === MaritalStatus.MARRIED && (
        <AutocompleteSelectFormField
          name={'maritalRegime'}
          label={'MARITAL_REGIME'}
          value={familiarSituationDetails.maritalSituation.maritalRegime}
          selectOptions={maritalRegimeArray}
          fieldVariant={fieldVariant}
        />
      )}
      <NumberFormField
        name={'childSupportNumber'}
        label={'CHILD_SUPPORT_NUMBER'}
        type="number"
        value={familiarSituationDetails.childSupportNumber}
        allowDecimals={false}
        fieldVariant={fieldVariant}
      />
    </FormGridContainer>
  );
}
